import React from 'react';
import WarehouseTable from '../../../components/RouteMasters/Warehouse/WarehouseTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <WarehouseTable />
        </ContentView>
    );
};
export default index;
